import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../styles/Buttons.css";

const AddButton = ({ onClick }) => {
    return (
        <button onClick={onClick} className="btn-icon btn-add" title="Add">
            <FontAwesomeIcon icon="plus" style={{ marginRight: "6px" }} />
            <span>Add</span>
        </button>
    );
};

export default AddButton;
